import {
    GET_ALL_USERS,
    GET_USERS_SUCCESS,
    GET_USERS_FAIL,
    DELETE_USER,
    DELETE_USER_SUCCESS,
    DELETE_USER_FAIL,
    GET_USER_HISTORY,
    GET_USER_HISTORY_SUCCESS,
    GET_USER_HISTORY_FAIL,
    SET_USER_FILTERS,
    CLEAR_USER_HISTORY,
    BULK_DELETE_USERS,
    BULK_DELETE_USERS_SUCCESS,
    BULK_DELETE_USERS_FAIL,
    SET_HISTORY_FILTERS,
    UPDATE_USER_STATUS,
    UPDATE_USER_STATUS_SUCCESS,
    UPDATE_USER_STATUS_FAIL,
    ADD_USER,
    ADD_USER_SUCCESS,
    ADD_USER_FAIL,
    GET_USER_BALANCE_HISTORY,
    GET_USER_BALANCE_HISTORY_SUCCESS,
    GET_USER_BALANCE_HISTORY_FAIL,
    UPDATE_USER_ONLINE_STATUS
} from "./thunk";

// Initial State
const initialState = {
    users: [],
    userHistory: {},
    historyPagination: {},
    historyFilters: {},
    loading: false,
    deleteLoading: false,
    bulkDeleteLoading: false,
    historyLoading: false,
    balanceHistoryLoading: false,
    userBalanceHistory: {},
    error: null,
    filters: {
        page: 1,
        limit: 10,
        search: "",
        order: "desc",
        orderBy: "createdAt",
        status: ""
    },
    pagination: {
        currentPage: 1,
        total: 0,
        totalPages: 1
    },
    selectedUsers: []
};

// Reducer
const usersReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get All Users
        case GET_ALL_USERS:
            return {
                ...state,
                loading: true,
                error: null
            };

        case UPDATE_USER_STATUS:
            return {
                ...state,
                loading: true, // You might want a specific actionLoading if preferred
                error: null
            };

        // Update User Status Success
        case UPDATE_USER_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                users: state.users.map(user =>
                    (user._id === action.payload.userId || user.id === action.payload.userId)
                        ? { ...user, ...action.payload.data } // Update isDeleted/isActive
                        : user
                )
            };

        case UPDATE_USER_STATUS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // Add User
        case ADD_USER:
            return {
                ...state,
                loading: true,
                error: null
            };

        case ADD_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                users: [action.payload, ...state.users], // Add new user to the top
                pagination: {
                    ...state.pagination,
                    total: state.pagination.total + 1
                }
            };

        case ADD_USER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case GET_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                users: action.payload.users,
                pagination: {
                    currentPage: action.payload.currentPage || state.filters.page,
                    total: action.payload.total,
                    totalPages: action.payload.totalPages || Math.ceil((action.payload.total || 1) / (action.payload.limit || 10))
                },
                filters: {
                    ...state.filters,
                    page: action.payload.page || state.filters.page,
                    limit: action.payload.limit || state.filters.limit,
                    search: action.payload.search || state.filters.search,
                    order: action.payload.order || state.filters.order,
                    orderBy: action.payload.orderBy || state.filters.orderBy
                }
            };

        case GET_USERS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                users: []
            };

        // Delete Single User
        case DELETE_USER:
            return {
                ...state,
                deleteLoading: true,
                error: null
            };

        case DELETE_USER_SUCCESS:
            return {
                ...state,
                deleteLoading: false,
                users: state.users.filter(user =>
                    user._id !== action.payload.userId && user.id !== action.payload.userId
                ),
                pagination: {
                    ...state.pagination,
                    total: state.pagination.total - 1
                }
            };

        case DELETE_USER_FAIL:
            return {
                ...state,
                deleteLoading: false,
                error: action.payload
            };

        // Bulk Delete Users
        case BULK_DELETE_USERS:
            return {
                ...state,
                bulkDeleteLoading: true,
                error: null
            };

        case BULK_DELETE_USERS_SUCCESS:
            return {
                ...state,
                bulkDeleteLoading: false,
                users: state.users.filter(user =>
                    !action.payload.userIds.includes(user._id) && !action.payload.userIds.includes(user.id)
                ),
                selectedUsers: [],
                pagination: {
                    ...state.pagination,
                    total: state.pagination.total - action.payload.userIds.length
                }
            };

        case BULK_DELETE_USERS_FAIL:
            return {
                ...state,
                bulkDeleteLoading: false,
                error: action.payload
            };

        // User History
        case GET_USER_HISTORY:
            return {
                ...state,
                historyLoading: true,
                error: null
            };

        case GET_USER_HISTORY_SUCCESS:
            return {
                ...state,
                historyLoading: false,
                userHistory: {
                    ...state.userHistory,
                    [action.payload.userId]: action.payload.history
                },
                historyPagination: {
                    ...state.historyPagination,
                    [action.payload.userId]: action.payload.pagination
                },
                historyFilters: {
                    ...state.historyFilters,
                    [action.payload.userId]: action.payload.filters
                }
            };

        case GET_USER_HISTORY_FAIL:
            return {
                ...state,
                historyLoading: false,
                error: action.payload
            };

        // Set History Filters
        case SET_HISTORY_FILTERS:
            return {
                ...state,
                historyFilters: {
                    ...state.historyFilters,
                    [action.payload.userId]: {
                        ...state.historyFilters[action.payload.userId],
                        ...action.payload.filters
                    }
                }
            };

        case CLEAR_USER_HISTORY:
            return {
                ...state,
                userHistory: {},
                historyPagination: {},
                historyFilters: {}
            };

        // Set User Filters
        case SET_USER_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload,
                    page: action.payload.page !== undefined ? action.payload.page : state.filters.page
                }
            };

        // Balance History
        case GET_USER_BALANCE_HISTORY:
            return {
                ...state,
                balanceHistoryLoading: true,
                error: null
            };

        case GET_USER_BALANCE_HISTORY_SUCCESS:
            return {
                ...state,
                balanceHistoryLoading: false,
                userBalanceHistory: {
                    ...state.userBalanceHistory,
                    [action.payload.userId]: action.payload.data
                }
            };

        case GET_USER_BALANCE_HISTORY_FAIL:
            return {
                ...state,
                balanceHistoryLoading: false,
                error: action.payload
            };

        // Real-time online status update from socket
        case UPDATE_USER_ONLINE_STATUS:
            return {
                ...state,
                users: state.users.map(user => {
                    const userId = String(user._id || user.id || "");
                    if (userId !== String(action.payload.userId || "")) return user;

                    const game = action.payload.game || action.payload.gameName;
                    let activeGames = [...(user.activeGames || [])];
                    if (action.payload.status === "online") {
                        if (game && game !== "UNKNOWN" && game !== "DEVICE" && !activeGames.includes(game)) {
                            activeGames.push(game);
                        }
                        return { ...user, isOnline: true, activeGames };
                    }

                    if (action.payload.isOnline === false) {
                        return { ...user, isOnline: false, activeGames: [] };
                    }
                    activeGames = activeGames.filter(g => g !== game);
                    return {
                        ...user,
                        isOnline: activeGames.length > 0,
                        activeGames
                    };
                })
            };

        default:
            return state;
    }
};

export default usersReducer;